import { Swiper, SwiperSlide } from "swiper/react";
import { Button } from "~/components";
import { useWindowWidth } from "~/utils/hooks/useWindowWidth";
import { IAuthorMainPage } from "~/utils/interface";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import Snow from "/img/authors/jenika-snow.png";
import Carr from "/img/authors/mari-carr.png";
import Henderson from "/img/authors/n-e-henderson.png";
import Lawson from "/img/authors/piper-lawson.png";
import Winters from "/img/authors/willow-winters.png";
import Rose from "/img/authors/renee-rose.png";
import Paige from "/img/authors/laurelin-paige.png";
import Cole from "/img/authors/samantha-a-cole.png";
import { useMemo } from "react";

const AUTHORS: IAuthorMainPage[] = [
  { name: "Jenika Snow", photo: Snow },
  { name: "Mari Carr", photo: Carr },
  { name: "N.E. Henderson", photo: Henderson },
  { name: "Piper Lawson", photo: Lawson },
  { name: "Willow Winters", photo: Winters },
  { name: "Renee Rose", photo: Rose },
  { name: "Laurelin Paige", photo: Paige },
  { name: "Samantha A. Cole", photo: Cole },
];

const Acclaimed = () => {
  const width = useWindowWidth();

  //This grouping is used for displaying reviews in a two-column layout, for example, where each pair of reviews is displayed side by side, with any odd review out displayed on its own.
  //
  // Input: [A, B, C, D, E]
  // Output: [[A, B], [C, D], [E]]
  const groupedAuthors = useMemo(() => {
    return AUTHORS.reduce<IAuthorMainPage[][]>((acc, review, index) => {
      if (index % 2 === 0) {
        acc.push([review]);
      } else {
        acc[acc.length - 1].push(review);
      }
      return acc;
    }, []);
  }, []);

  return (
    <section className="max-md:pt-8 max-md:pb-0 py-[100px]" id="acclaimed">
      <div className="container">
        <div className="grid max-md:grid-cols-1 max-2xl:grid-cols-[1fr_2fr] grid-cols-[564px_1fr] gap-8 items-center">
          <div className="px-8 max-2xl:px-0">
            <h2 className="max-lg:text-4xl max-lg:leading-[49px] text-center text-white text-5xl font-extrabold leading-[60px]">
              Acclaimed Authors and Narrators
            </h2>
            <p className="max-lg:mb-8 max-lg:text-xl max-lg:leading-7 text-center text-white text-2xl font-light tracking-tight mt-4 mb-12">
              No AI, just real voices that make every story come to life
            </p>
            {width < 768 && (
              <Swiper
                className="max-md:pb-8 authors__slider"
                slidesPerView={4}
                loop
                modules={[Autoplay]}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 3,
                  },
                }}
              >
                {groupedAuthors.map((pair, index) => (
                  <SwiperSlide key={index}>
                    <div>
                      {pair.map((author) => (
                        <div key={author.name} className="mb-12 last:mb-0">
                          <img
                            className="max-xl:w-[100px] max-xl:h-[100px] w-40 h-40 mx-auto rounded-full"
                            src={author.photo}
                            alt={author.name}
                          />
                          <div className="text-center text-white text-base font-normal tracking-tight mt-2">
                            {author.name}
                          </div>
                        </div>
                      ))}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            <div className="max-md:mt-6 flex justify-center">
              <Button className="max-md:w-full max-md:px-0 max-lg:px-10 px-24" />
            </div>
          </div>
          {width > 767 && (
            <div className="max-lg:gap-4 grid grid-cols-4 px-6 gap-4 max-2xl:px-0">
              {groupedAuthors.map((pair, index) => (
                <div key={`group_${index}`}>
                  {pair.map((author) => (
                    <div key={author.name} className="mb-12 last:mb-0">
                      <img
                        className="max-xl:w-[100px] max-xl:h-[100px] w-40 h-40 mx-auto rounded-full"
                        src={author.photo}
                        alt={author.name}
                      />
                      <div className="text-center text-white text-base font-normal tracking-tight mt-2">
                        {author.name}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

Acclaimed.displayName = "Acclaimed";

export default Acclaimed;
